const TAILSCALE_URL = "https://expedibox-admin.taild07d0.ts.net";
const TAILSCALE_WS_URL = "wss://expedibox-ws.taild07d0.ts.net";

export interface AppConfig {
  lockerId: string;
  apiKey: string;
  apiUrl: string;
  wsUrl: string;
  app: string;
  branding: string;
  phoenixUrl: string;
}

const normalizeBranding = (value?: string | null) =>
  value?.trim().toLowerCase() === "parcelone" ? "parcelone" : "expedibox";

export function initConfig(key: string, hint?: string, prompt = true) {
  const urlParams = new URLSearchParams(window.location.search);
  // 1) URL param
  let value = urlParams.get(key) ?? undefined;
  // 2) Local storage
  if (!value) value = localStorage.getItem(key) ?? undefined;
  // 3) Prompt (avoid in tests)
  if (!value && prompt && process.env.NODE_ENV !== "test") {
    value = window.prompt(key, hint) ?? undefined;
  }

  if (typeof value === "string" && value.length > 0) {
    localStorage.setItem(key, value);
  } else if (process.env.NODE_ENV === "development" && prompt) {
    console.error(`${key} is null`);
  }
}

export function getConfig(): AppConfig {
  const read = (k: string, fallback: string) => localStorage.getItem(k) || fallback;
  const app = read("app", "locker");
  const lockerId = read("lockerId", "");
  const apiKey = read("apiKey", "");
  const tailscale = read("tailscale", "");
  let apiUrl = read("apiUrl", "");
  let wsUrl = read("wsUrl", "");
  if (tailscale) {
    apiUrl = TAILSCALE_URL;
    wsUrl = TAILSCALE_WS_URL;
  }
  const branding = normalizeBranding(read("branding", "expedibox"));
  const phoenixUrl = read("phoenixUrl", "https://phoenix.xpdbx.co");
  return {
    lockerId,
    apiKey,
    apiUrl,
    wsUrl,
    app,
    branding,
    phoenixUrl,
  };
}

/**
 * Quick Configuration
 */
const params = new URLSearchParams(window.location.search);

if (params.has("test")) {
  localStorage.setItem("apiKey", "0ab81908-bad1-461e-adcd-a599d871f7a2");
  localStorage.setItem("lockerId", "MmD8W26G");
  localStorage.setItem("apiUrl", "https://api.expedibox.com");
  localStorage.setItem("wsUrl", "wss://35.203.109.132");
  localStorage.setItem("phoenixUrl", "https://phoenix.xpdbx.co");
} else if (params.has("staging")) {
  localStorage.setItem("apiKey", "0ab81908-bad1-461e-adcd-a599d871f7a2");
  localStorage.setItem("lockerId", "MmD8W26G");
  localStorage.setItem("apiUrl", "https://staging.api.expedibox.com");
  localStorage.setItem("wsUrl", "wss://staging.api.expedibox.com");
  localStorage.setItem("phoenixUrl", "https://phoenix.xpdbx.co");
  localStorage.setItem("mockDoor", "true");
  localStorage.setItem("mockWs", "true");
} else if (params.has("dev")) {
  localStorage.setItem("apiKey", "4b2971c3-a587-4709-8e56-b7a656d2b2c1");
  localStorage.setItem("lockerId", "7WJz7GqZ");
  localStorage.setItem("apiUrl", "http://api.expediboxdev.com:8000");
  localStorage.setItem("wsUrl", "ws://127.0.0.1:8000");
  localStorage.setItem("phoenixUrl", "http://api.expediboxdev.com:8000");
} else {
  initConfig("lockerId");
  initConfig("apiKey");
  initConfig("apiUrl", "http://api.expediboxdev.com:8000");
  initConfig("wsUrl", "ws://127.0.0.1:8000");
  initConfig("app", "locker", false);
  initConfig("branding", "expedibox", false);
  initConfig("phoenixUrl", "http://api.expediboxdev.com:8000", false);
}

if (params.has("tailscale")) {
  localStorage.setItem("tailscale", "true");
  localStorage.setItem("apiUrl", TAILSCALE_URL);
  localStorage.setItem("wsUrl", TAILSCALE_WS_URL);
}

if (params.has("mockDoor")) {
  localStorage.setItem("mockDoor", "true");
}

if (params.has("realDoor")) {
  localStorage.removeItem("mockDoor");
}

if (params.has("mockWs")) {
  localStorage.setItem("mockWs", "true");
}

if (params.has("realWs")) {
  localStorage.removeItem("mockWs");
}
